<div class="filter-container">

  <!-- 検索条件バー -->
  <div class="search-bar">
    @if (showCondition.length === 0) {
      <span class="search-placeholder">検索条件</span>
    }

    <div class="chip-scroll">
      <div class="chip-group-row">
        @for (group of showCondition; track group.type; let gIdx = $index) {
          @for (chip of group.data; track chip.id; let first = $first; let last = $last; let cIdx = $index) {
            <div class="chip-unit" [class.margin-right]="last" [attr.data-chip-key]="group.type + '-' + chip.id">
              @if (!first) {
                <div class="chip-connector"></div>
              }
              <div class="chip">
                <span class="chip-text">{{ chip.label }}{{ chip.title }}</span>
                <button type="button" class="chip-close" aria-label="この条件を削除" (click)="onRemoveChip(gIdx, cIdx)">
                  <img src="assets/common/filter-close.svg" alt="">
                </button>
              </div>
            </div>
          }
        }
      </div>
    </div>

    @if (showCondition.length > 0) {
      <button type="button" class="clear-all-button" aria-label="すべての条件を削除" (click)="onClearAll()">
        <img src="assets/common/filter-close.svg" alt="">
      </button>
    }
  </div>

  <!-- タブナビ + パネル -->
  <div class="tab-nav-wrapper" #tabNavWrapper>
    <div class="tab-nav">
      @for (tab of tabs; track tab.title; let tIdx = $index) {
        <button type="button" class="tab-item"
          [class.active]="selectedTabIdx === tIdx"
          [class.selected]="tabHasSelection(tIdx)"
          (click)="onTab(tIdx, $event)">
          <span class="tab-label-group">
            <span class="tab-label">{{ tab.title }}</span>
            <svg viewBox="0 0 24 24" width="24px" height="24px" focusable="false"><path d="M7 10l5 5 5-5z"></path></svg>
          </span>
        </button>
      }
    </div>

    @if (selectedTabIdx !== null) {
      @switch (selectedTabIdx) {

        <!-- カテゴリー -->
        @case (0) {
          <div class="panel category-panel" [style.left.px]="panelLeft" [style.right.px]="panelRight">
            <div class="category-major-list">
              @for (major of getMaster(Constant.esMasterTypeCategoryMajor); track major.id) {
                <label class="category-major-item radio-label">
                  <input type="radio" name="categoryMajor"
                    [value]="major.id"
                    [checked]="selectedCategoryMajorId === major.id"
                    (change)="onSelectCategoryMajor(major.id)">
                  {{ major.name }}
                </label>
              }
            </div>
            <div class="category-sub-list">
              @if (selectedCategoryMajorId == null) {
                <div class="category-sub-empty">カテゴリーを選択してください。</div>
              } @else {
                <div class="checkbox-columns">
                  @for (sub of getCategorySubMaster(); track sub.id) {
                    <mat-checkbox
                      class="thin-checkbox"
                      [disableRipple]="true"
                      [checked]="isSelected(Constant.esConditionTypeCategorySub, sub.id)"
                      (change)="onToggleCondition(Constant.esConditionTypeCategorySub, sub.id, $event.checked)">
                      {{ sub.name }}
                    </mat-checkbox>
                  }
                </div>
              }
            </div>
          </div>
        }

        <!-- 目的等 -->
        @case (1) {
          <div class="panel purpose-panel" [style.left.px]="panelLeft" [style.right.px]="panelRight">
            <div class="panel-sidenav">
              @for (nav of purposeSidenav; track nav.title; let nIdx = $index) {
                <div class="sidenav-item" [class.active]="selectedSidenavIdx === nIdx" (click)="onSidenav(nIdx)">
                  {{ nav.title }}
                  @if (sidenavHasSelection(nav.types)) {
                    <span class="selected-mark">選択中</span>
                  }
                </div>
              }
            </div>
            <div class="panel-content">
              @if (selectedSidenavIdx === 0) {
                <div class="content-section">
                  <div class="checkbox-columns">
                    @for (item of getMaster(Constant.esMasterTypePurpose); track item.id) {
                      <mat-checkbox
                        class="thin-checkbox"
                        [disableRipple]="true"
                        [checked]="isSelected(Constant.esConditionTypePurpose, item.id)"
                        (change)="onToggleCondition(Constant.esConditionTypePurpose, item.id, $event.checked)">
                        {{ item.name }}
                      </mat-checkbox>
                    }
                  </div>
                </div>
              } @else if (selectedSidenavIdx === 1) {
                <div class="content-section">
                  <div class="checkbox-columns">
                    @for (item of getMaster(Constant.esMasterTypeSocialTheme); track item.id) {
                      <mat-checkbox
                        class="thin-checkbox"
                        [disableRipple]="true"
                        [checked]="isSelected(Constant.esConditionTypeSocialTheme, item.id)"
                        (change)="onToggleCondition(Constant.esConditionTypeSocialTheme, item.id, $event.checked)">
                        {{ item.name }}
                      </mat-checkbox>
                    }
                  </div>
                </div>
              } @else {
                <div class="content-section">
                  <div class="content-section-title">状態の変化</div>
                  <div class="checkbox-columns">
                    @for (item of getMaster(Constant.esMasterTypeImproveState); track item.id) {
                      <mat-checkbox
                        class="thin-checkbox"
                        [disableRipple]="true"
                        [checked]="isSelected(Constant.esConditionTypeImproveState, item.id)"
                        (change)="onToggleCondition(Constant.esConditionTypeImproveState, item.id, $event.checked)">
                        {{ item.name }}
                      </mat-checkbox>
                    }
                  </div>
                </div>
                <div class="content-section">
                  <div class="content-section-title">企画の成果</div>
                  <div class="checkbox-columns">
                    @for (item of getMaster(Constant.esMasterTypeImproveOutcome); track item.id) {
                      <mat-checkbox
                        class="thin-checkbox"
                        [disableRipple]="true"
                        [checked]="isSelected(Constant.esConditionTypeImproveOutcome, item.id)"
                        (change)="onToggleCondition(Constant.esConditionTypeImproveOutcome, item.id, $event.checked)">
                        {{ item.name }}
                      </mat-checkbox>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <!-- 対象等 -->
        @case (2) {
          <div class="panel target-panel" [style.left.px]="panelLeft" [style.right.px]="panelRight">
            <div class="panel-sidenav">
              @for (nav of targetSidenav; track nav.title; let nIdx = $index) {
                <div class="sidenav-item" [class.active]="selectedSidenavIdx === nIdx" (click)="onSidenav(nIdx)">
                  {{ nav.title }}
                  @if (sidenavHasSelection(nav.types)) {
                    <span class="selected-mark">選択中</span>
                  }
                </div>
              }
            </div>
            <div class="panel-content">
              @if (selectedSidenavIdx === 0) {
                <div class="content-section">
                  <div class="checkbox-columns">
                    @for (item of getOrganizerUnitMaster(); track item.id) {
                      <mat-checkbox
                        class="thin-checkbox"
                        [disableRipple]="true"
                        [checked]="isSelected(Constant.esConditionTypeOrganizerUnit, item.id)"
                        (change)="onToggleCondition(Constant.esConditionTypeOrganizerUnit, item.id, $event.checked)">
                        {{ item.name }}
                      </mat-checkbox>
                    }
                  </div>
                </div>
              } @else {
                <div class="content-section">
                  <div class="checkbox-columns">
                    @for (item of getMaster(Constant.esMasterTypeParticipantCategory); track item.id) {
                      <mat-checkbox
                        class="thin-checkbox"
                        [disableRipple]="true"
                        [checked]="isSelected(Constant.esConditionTypeParticipantCategory, item.id)"
                        (change)="onToggleCondition(Constant.esConditionTypeParticipantCategory, item.id, $event.checked)">
                        {{ item.name }}
                      </mat-checkbox>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <!-- キーワード -->
        @case (3) {
          <div class="panel keyword-panel" [style.left.px]="panelLeft" [style.right.px]="panelRight">
            <div class="panel-content">
              <div class="content-section">
                <div class="content-section-title">タイトル<span class="content-section-note">※{{ Constant.esKeywordMaxCount }}つまで</span></div>
                <div class="keyword-input-row">
                  <input class="keyword-input" type="text" [attr.maxlength]="Constant.esKeywordMaxLen" placeholder="検索ワードを入力"
                    [disabled]="!canAddKeyword(Constant.esConditionTypeKeywordTitle)"
                    [(ngModel)]="keywordTitleInput">
                  <button type="button" class="keyword-add-button"
                    [disabled]="!canAddKeyword(Constant.esConditionTypeKeywordTitle)"
                    (click)="addKeyword(Constant.esConditionTypeKeywordTitle)">追加</button>
                </div>
              </div>
              <div class="content-section">
                <div class="content-section-title">概要<span class="content-section-note">※{{ Constant.esKeywordMaxCount }}つまで</span></div>
                <div class="keyword-input-row">
                  <input class="keyword-input" type="text" [attr.maxlength]="Constant.esKeywordMaxLen" placeholder="検索ワードを入力"
                    [disabled]="!canAddKeyword(Constant.esConditionTypeKeywordSummary)"
                    [(ngModel)]="keywordSummaryInput">
                  <button type="button" class="keyword-add-button"
                    [disabled]="!canAddKeyword(Constant.esConditionTypeKeywordSummary)"
                    (click)="addKeyword(Constant.esConditionTypeKeywordSummary)">追加</button>
                </div>
              </div>
            </div>
          </div>
        }

        <!-- 検索範囲 -->
        @case (4) {
          <div class="panel scope-panel" [style.left.px]="panelLeft" [style.right.px]="panelRight">
            <div class="panel-sidenav">
              <div class="sidenav-item active">
                作成組織
                @if (scopeOrg) {
                  <span class="selected-mark">選択中</span>
                }
              </div>
            </div>
            <div class="panel-content">
              <div class="radio-row">
                <label class="radio-label">
                  <input type="radio" name="scopeOrg"
                    [value]="Constant.esScopeOwn"
                    [checked]="scopeOrg === Constant.esScopeOwn"
                    (change)="onSelectScope(Constant.esScopeOwn)">
                  自組織のみ
                </label>
                <label class="radio-label radio-label-wide">
                  <input type="radio" name="scopeOrg"
                    [value]="Constant.esScopeOther"
                    [checked]="scopeOrg === Constant.esScopeOther"
                    (change)="onSelectScope(Constant.esScopeOther)">
                  他組織のみ
                </label>
              </div>
            </div>
          </div>
        }
      }
    }
  </div>

</div>

  <!-- 並び替えボタン -->
  <div class="sort-section">
    <mat-form-field class="sort-button no-line" appearance="fill" subscriptSizing="dynamic">
      <mat-select
        [value]="order"
        (selectionChange)="onOrderChange($event.value)"
        disableOptionCentering="false"
        panelClass="event-search-order-select">
        <mat-select-trigger>
          <img src="assets/common/list_filter.svg" alt="" matPrefix>
          {{ selectedOrderLabel }}
        </mat-select-trigger>
        @for (opt of orderOptions; track opt.value) {
          <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>